import { Protected } from '$features/auth/components/guards/protected'
import { DashboardPage } from '$features/dashboard/pages/dashboard'
import { RouteObject, Outlet } from 'react-router'
import { RoutePath } from 'src/enums/routing'
import { DashboardLayout } from 'src/layouts/dashboard'
import { protectedPetRoutes } from '$features/pets/routes/protected'
import { protectedCalendarRoutes } from '$features/calendar/routes/protected'
import { protectedClientRoutes } from '$features/clients/routes/protected'
import { protectedAppointmentRoutes } from '$features/appointments/routes/protected'
import { protectedServiceRoutes } from '$features/services/routes/protected'
import { protectedSettingsRoutes } from '$features/settings/routes/protected'
import { protectedTeamRoutes } from '$features/team/routes/protected'
import { protectedOnboardingRoutes } from '$features/onboarding/routes/protected'
import { OnboardingProvider } from '$features/onboarding/components/onboarding-provider'
import { RequiresOnboardingCompletion } from '$features/onboarding/components/guards/requires-onboarding-completion'

export const protectedRoutes: RouteObject[] = [
  {
    element: (
      <Protected>
        <OnboardingProvider>
          <RequiresOnboardingCompletion>
            <Outlet />
          </RequiresOnboardingCompletion>
        </OnboardingProvider>
      </Protected>
    ),
    children: [
      ...protectedOnboardingRoutes,
      {
        path: RoutePath.Root,
        element: <DashboardLayout />,
        children: [
          {
            index: true,
            element: <DashboardPage />,
          },
          ...protectedPetRoutes,
          ...protectedCalendarRoutes,
          ...protectedClientRoutes,
          ...protectedAppointmentRoutes,
          ...protectedServiceRoutes,
          ...protectedTeamRoutes,
          ...protectedSettingsRoutes,
        ],
      },
    ],
  },
]
